import { FileViewModel, ListLocationModel } from "client/Api/Documents/SharePoint/common";
import { urlEncodeObject } from "client_legacy/ndaw/urlHelper";
import { environmentHttpClient } from "../httpClient";
import {
	EmailAttachmentResultModel,
	InsertAttachmentsToExchangeEmailRequestModel,
	MailMessageLocationModel,
	MailMessageLocationQueryModel
} from "./common";

export type SharePointEmailAttachmentModel = {
	fileId: number;
	location: ListLocationModel;
};

export async function uploadSharePointAttachments(
	data: InsertAttachmentsToExchangeEmailRequestModel<SharePointEmailAttachmentModel>,
	signal?: AbortSignal
): Promise<readonly EmailAttachmentResultModel[]> {
	return environmentHttpClient.post<readonly EmailAttachmentResultModel[]>(
		"Email/Attachments/SharePoint/Attach",
		data,
		{ signal }
	);
}

export type SaveAttachmentToSharePointResponseModel = {
	file: FileViewModel;
};

export function saveAttachment(
	messageLocation: MailMessageLocationQueryModel,
	attachmentId: string,
	folderName: string | nil,
	signal?: AbortSignal
): Promise<SaveAttachmentToSharePointResponseModel> {
	// It is important that the null values don't end up in the query string (the backend expect it)
	const queryString: string = urlEncodeObject(
		{
			smtpAddress: messageLocation.smtpAddress,
			messageId: messageLocation.messageId,
			attachmentId,
			folderName
		},
		true
	);

	return environmentHttpClient.get<SaveAttachmentToSharePointResponseModel>(
		`Email/Attachments/SharePoint/Save?${queryString}`,
		undefined,
		{ signal }
	);
}

export type SaveAttachmentAsOnSharePointModel = {
	name: string;
	folderId: number | null;
	location: ListLocationModel;
	message: MailMessageLocationModel;
	exchangeAttachmentId: string;
};

export type SaveAsAttachmentToSharePointResponseModel = {
	file: FileViewModel;
};

export function saveAttachmentAsOnSharepoint(
	saveData: SaveAttachmentAsOnSharePointModel,
	signal?: AbortSignal
): Promise<SaveAsAttachmentToSharePointResponseModel> {
	return environmentHttpClient.post<SaveAsAttachmentToSharePointResponseModel>(
		"Email/Attachments/SharePoint/SaveAs",
		saveData,
		{ signal }
	);
}
